import { render, staticRenderFns } from "./taskAssign.vue?vue&type=template&id=055bf2b8&scoped=true"
import script from "./taskAssign.vue?vue&type=script&lang=js"
export * from "./taskAssign.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "055bf2b8",
  null
  
)

export default component.exports